/* eslint-disable consistent-return */
/* eslint-disable array-callback-return */
/* eslint-disable no-mixed-operators */
/* eslint-disable import/prefer-default-export */
import moment from 'moment';
import numeral from 'numeral';
import _ from 'lodash';
import api from 'shared/services/api';
import { COMPONENT_TYPE, FUND_TYPES } from 'shared/constants';
import { ACTION_TYPE } from './actionTypes';
import productsData from '../../../pages/ProductRecommendation/data.json';


export const getAllFunds = list => dispatch => new Promise((resolve) => {
  api.getAllFunds(list)
    .then((res) => {
      let newFunds = res;
      newFunds = newFunds
        .map(item => ({
          ...item,
        }));
      dispatch({
        type: ACTION_TYPE.GET_PRODUCTS_OVERVIEW,
        payload: newFunds,
      });
      resolve();
    });
});


const array = [];
for (let i = 0; i < productsData.length; i += 1) {
  for (let j = 0; j < productsData[i].masterData.length; j += 1) {
    array.push(productsData[i].masterData[j]);
  }
}

const fundMasterData = _.uniqBy(array, elem => [elem.componentType, elem.title].join());

// const componentGroup = {
//   keyFacts: fundMasterData.filter(item => item.componentType === COMPONENT_TYPE.KEY_FACTS),
//   portfolioStat: fundMasterData.filter(item => item.componentType === COMPONENT_TYPE.PORTFOLIO_STAT),
//   itemList: fundMasterData.filter(item => item.componentType === COMPONENT_TYPE.ITEM_LIST),
//   pieChart: fundMasterData.filter(item => item.componentType === COMPONENT_TYPE.PIE_CHART),
//   lineChart: fundMasterData.filter(item => item.componentType === COMPONENT_TYPE.LINE_CHART),
//   horizontalBarChar: fundMasterData.filter(item => item.componentType === COMPONENT_TYPE.HORIZONAL_BAR_CHART),
//   pastPerformance: fundMasterData.filter(item => item.componentType === COMPONENT_TYPE.PAST_PERFORMANCE),
//   barChart: fundMasterData.filter(item => item.componentType === COMPONENT_TYPE.BAR_CHART),
// };
// console.log(componentGroup);

const keyFacts = fundMasterData.find(item => item.componentType === COMPONENT_TYPE.KEY_FACTS);
const itemListTopping = title => fundMasterData.find((item) => {
  if (item.componentType === COMPONENT_TYPE.ITEM_LIST && item.title === title) {
    return item;
  }
});
const geographicAllocation = fundMasterData.find(item => item.componentType === COMPONENT_TYPE.HORIZONAL_BAR_CHART);
const portfolioStats = title => fundMasterData.find((item) => {
  if (item.componentType === COMPONENT_TYPE.PORTFOLIO_STAT && item.title === title) {
    return item;
  }
});
const pieChartForAllocation = title => fundMasterData.find((item) => {
  if (item.componentType === COMPONENT_TYPE.PIE_CHART && item.title === title) {
    return item;
  }
});
const pastPerformance = fundMasterData.find(item => item.componentType === COMPONENT_TYPE.PAST_PERFORMANCE);
const lineChartForGrowth = title => fundMasterData.find((item) => {
  if (item.componentType === COMPONENT_TYPE.LINE_CHART && item.title === title) {
    return item;
  }
});


const filterFundDetailMD = (fundType) => {
  if (fundType === FUND_TYPES.ISHARES) {
    return [
      // keyfacts
      keyFacts,
      // sector allocation
      pieChartForAllocation('Sector allocation'),
      // geographic allocation
      geographicAllocation,
      // Top Holdings (%)
      itemListTopping('Top Holdings (%)'),
      // pass performance
      pastPerformance,
      // Growth of 10,000 USD Since Inception
      lineChartForGrowth('Growth of 10,000 USD Since Inception'),
    ];
  }
  if (fundType === FUND_TYPES.ISLAMIC) {
    return [
      // keyfacts
      keyFacts,
      // sector allocation
      pieChartForAllocation('Sector allocation'),
      // Top 5 Holdings (69% of NAV)
      itemListTopping('Top 5 Holdings (59% of NAV)'),
      // pass performance
      pastPerformance,
      // Fund price performance - 1 KD invested since inception
      lineChartForGrowth('Fund price performance - 1 KD invested since inception'),
    ];
  }
  if (fundType === FUND_TYPES.MARKAZ) {
    return [
      // keyfacts
      keyFacts,
      // Portfolio Statistics
      portfolioStats('Portfolio Statistics'),
      // Portfolio Composition
      pieChartForAllocation('Portfolio Composition'),
      // Top Buildings
      itemListTopping('Top Buildings'),
      // pass performance
      pastPerformance,
      // Growth of Fund
      lineChartForGrowth('Growth of Fund'),
    ];
  }
  if (fundType === FUND_TYPES.MUMTAZ) {
    return [
      // keyfacts
      keyFacts,
      // Sector Allocation
      pieChartForAllocation('Sector allocation'),
      // Top 5 Holdings (59% of NAV)
      itemListTopping('Top 5 Holdings (59% of NAV)'),
      // pass performance
      pastPerformance,
      // Fund price performance vs. benchmark
      lineChartForGrowth('Fund price performance vs. benchmark'),
    ];
  }
  if (fundType === FUND_TYPES.DESCRETIONARY) {
    return [
      // Key facts
      keyFacts,
      // Sector Allocation
      pieChartForAllocation('Sector allocation'),
      // Geographic Allocation
      geographicAllocation,
      // Top Holdings
      itemListTopping('Top Holdings'),
      // Past performance
      pastPerformance,
    ];
  }
  if (fundType === FUND_TYPES.MFIF) {
    return [
      // Key facts
      keyFacts,
      // Sector Allocation
      pieChartForAllocation('Sector allocation'),
      // Geographic Allocation
      geographicAllocation,
      // Risk Metrics
      portfolioStats('Risk Metrics'),
      // Top Holdings
      itemListTopping('Top Holdings'),
      // Past performance
      pastPerformance,
      // Maturity Profile
      fundMasterData.find(item => item.componentType === COMPONENT_TYPE.BAR_CHART),
    ];
  }
  return fundMasterData;
};

const fundWithEtf = selectedFund => [
  // • Net Assets
  // {
  //   title: 'products.netAssets',
  //   value: selectedFund.netAssets || '',
  // },
  // // • NAV/Unit
  // {
  //   title: 'products.navUnit',
  //   value: '',
  // },
  // • Issuer
  // {
  //   title: 'products.issuer',
  //   value: selectedFund.issuer || '',
  // },
  // • 3Y Performance
  {
    title: 'products.fundInception',
    value: moment(selectedFund.fundInterception).format('MMMM YYYY') || '',
  },
  // • Fund Inception
  {
    title: 'products.3yPerformance',
    value: `${numeral(selectedFund.threeYearPerformance).format('0,0.00')} %` || '',
  },
];

const fundWithoutEtf = selectedFund => [
  // • Net Assets
  // {
  //   title: 'products.netAssets',
  //   value: selectedFund.netAssets || '',
  // },
  // // • NAV/Unit
  // {
  //   title: 'products.navUnit',
  //   value: '',
  // },
  // // • Subscription/Redemption
  // {
  //   title: 'products.subscription',
  //   value: selectedFund.subscription || '',
  // },
  // • 3Y Performance
  {
    title: 'products.fundInception',
    value: moment(selectedFund.fundInterception).format('MMMM YYYY') || '',
  },
  // • Fund Inception
  {
    title: 'products.3yPerformance',
    value: `${numeral(selectedFund.threeYearPerformance).format('0,0.00')} %` || '',
  },
];

export const mapFundDetail = fundId => (dispatch, getState) => {
  const { funds } = getState().fundFactsheetReducer;
  const selectedFund = funds.find(x => x.fundId === fundId);
  const data = {
    fundId,
    fundType: selectedFund.fundType,
    isin: selectedFund.isin,
    logo: selectedFund.logo,
    banner: selectedFund.banner,
    title: selectedFund.fundName,
    description: selectedFund.fundDescription,
    masterData: filterFundDetailMD(selectedFund.fundType).map((smallItem) => {
      if (smallItem) {
        // overwrite key facts values
        if (smallItem.componentType === COMPONENT_TYPE.KEY_FACTS) {
        // overwtire key facts values in case of etf fund type
          if (selectedFund.fundType === FUND_TYPES.ISHARES) {
            return { ...smallItem, data: fundWithEtf(selectedFund) };
          }
          return { ...smallItem, data: fundWithoutEtf(selectedFund) };
        }
        // using hardcode by default
        return { ...smallItem };
      }
    }),
  };
  dispatch({
    type: ACTION_TYPE.SAVE_FUND_FACTSHEET,
    payload: data,
  });
};
